import { DiscountStatus } from 'modules/discounts/types/discount.types';
import { DiscountLifecycleStatus, STATUS_TYPE_TO_STRING_MAP } from '../../constants';
import { DiscountStatusBadge as StyledBadge } from '../../views/Discounts.style';


const STATUS_VARIANT_KEY: Record<string, string> = {
  [DiscountLifecycleStatus.Scheduled]: '',
  [DiscountLifecycleStatus.Active]: 'active',
  [DiscountLifecycleStatus.Stopped]: 'stopped',
  [DiscountLifecycleStatus.Completed]: 'completed',
};

interface DiscountStatusBadgeProps {
  status: DiscountStatus;
}

const DiscountStatusBadge = ({ status }: DiscountStatusBadgeProps) => {
  const label = STATUS_TYPE_TO_STRING_MAP[status];
  const variant = STATUS_VARIANT_KEY[status];

  return <StyledBadge $variant={variant}>{label}</StyledBadge>;
};

export default DiscountStatusBadge;
